import { LiveStreamSettings } from "@nova/db-table-integration-authorizations"
import { fetchApiGateway } from "@nova/fetch-api-gateway"
import { invalidateIntegrationAuthorizations } from "features/data-management/integrations/useIntegrations"
import useSWRMutation from "swr/mutation"

interface CreateLiveStreamAuthorization {
    workspaceId: string
    settings: LiveStreamSettings
}

const useCreateLiveStreamAuthorization = () => {
    const { trigger, isMutating } = useSWRMutation(
        "live-stream-authorize",
        async (_key: string, { arg }: { arg: CreateLiveStreamAuthorization }) =>
            await fetchApiGateway("post /org/:orgId/integrations/live-stream/authorize", {
                params: { orgId: arg.workspaceId },
                body: { settings: arg.settings },
            }),
        { onSuccess: () => invalidateIntegrationAuthorizations() }
    )

    return { trigger, isMutating }
}

export { useCreateLiveStreamAuthorization }
